/* eslint-disable import/prefer-default-export */
import { useQuery } from "@tanstack/react-query";
import type { AccountMappingListResponse } from "api/models";
import { getAccountMappings } from "api/services/user";
import { userQueryKeys } from "./userQueryKeys";

export function useGetAccountMappings(filters: Record<string, unknown>) {
  return useQuery({
    queryKey: userQueryKeys.accountMappings(filters),
    queryFn: () => getAccountMappings({ params: filters }).then((res) => res.data as AccountMappingListResponse),
  });
}
